import Vue from "vue";
import Router from "vue-router";
import HomeIndex from "../views/index";
import ShowIndex from "../views/show";
import IndustryChain from "../views/industryChain";
import MapIndex from "../views/mapIndex";
import dataIndex from "../views/dataIndex.vue";
import Login from "../views/login.vue";
import commonView from "../components/indexCommonView.vue";
Vue.use(Router);

// 公共路由
export const constantRoutes = [
  {
    path: "",
    component: commonView,
    children: [
      {
        path: "/show",
        name: "园区推介",
        component: HomeIndex,
      },
      {
        path: "",
        name: "利通经济",
        component: ShowIndex,
      },
      {
        path: "/industryChain",
        name: "招商引资",
        component: IndustryChain,
      },
      {
        path: "/mapIndex",
        name: "玩转利通",
        component: MapIndex,
      },
      {
        path: "/dataIndex",
        name: "居民数据",
        component: dataIndex,
      },
    ],
  },
  {
    path: "/login",
    name: "登录",
    component: Login,
  },
];

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [];

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};

export default new Router({
  mode: "history", // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
});
